import React from 'react';

export default function ButtonLoading({radius = 15}) {
  return (
    <div
      style={{
        borderWidth: '2px',
        width: radius,
        height: radius
      }}
      className="spinner-border text-dark"
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};